import { Badge } from "@/components/ui/badge";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

type Level6ItemProps = {
  item: {
    id: number;
    name: string;
    index: string;
    title?: string;
    description?: string;
    node_1?: string;
    node_2?: string;
    node_3?: string;
    node_4?: string;
    node_5?: string;
    node_6?: string;
    product_count?: string;
    url?: string;
    cat_text?: string;
  };
};

export const Level6Item = ({ item }: Level6ItemProps) => {
  return (
    <div className="flex items-center gap-4 p-4 rounded-lg bg-muted/50">
      <div className="w-5" />
      <div className="flex-1 space-y-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="font-medium">
              {item.url ? (
                <a 
                  href={item.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:underline"
                  onClick={(e) => e.stopPropagation()}
                >
                  {item.name}
                </a>
              ) : (
                item.name
              )}
            </div>
            <Badge 
              variant={item.index === "index, follow" ? "default" : "destructive"}
            >
              {item.index}
            </Badge>
            <Badge
              variant={item.cat_text ? "default" : "secondary"}
              className={item.cat_text ? "bg-green-500" : "bg-red-200"}
            >
              {item.cat_text ? "Found content" : "no content"}
            </Badge>
          </div>
          {item.product_count && (
            <div className="text-sm text-muted-foreground">
              Products: {item.product_count}
            </div>
          )}
        </div>
        {item.title && (
          <p className="text-sm text-muted-foreground text-left font-medium">
            {item.title}
          </p>
        )}
        {item.description && (
          <p className="text-sm text-muted-foreground text-left">
            {item.description}
          </p>
        )}
        <div className="text-sm text-muted-foreground">
          {(item.node_1 || item.node_2 || item.node_3 || item.node_4 || item.node_5 || item.node_6) && (
            <Breadcrumb>
              <BreadcrumbList>
                {item.node_1 && (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink href="#">{item.node_1}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {(item.node_2 || item.node_3 || item.node_4 || item.node_5 || item.node_6) && <BreadcrumbSeparator />}
                  </>
                )}
                {item.node_2 && (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink href="#">{item.node_2}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {(item.node_3 || item.node_4 || item.node_5 || item.node_6) && <BreadcrumbSeparator />}
                  </>
                )}
                {item.node_3 && (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink href="#">{item.node_3}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {(item.node_4 || item.node_5 || item.node_6) && <BreadcrumbSeparator />}
                  </>
                )}
                {item.node_4 && (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink href="#">{item.node_4}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {(item.node_5 || item.node_6) && <BreadcrumbSeparator />}
                  </>
                )}
                {item.node_5 && (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink href="#">{item.node_5}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {item.node_6 && <BreadcrumbSeparator />}
                  </>
                )}
                {item.node_6 && (
                  <BreadcrumbItem>
                    <BreadcrumbLink href="#">{item.node_6}</BreadcrumbLink>
                  </BreadcrumbItem>
                )}
              </BreadcrumbList>
            </Breadcrumb>
          )}
        </div>
      </div>
    </div>
  );
};